import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import CSSModules from 'react-css-modules';
import Button from '../Button';
import ErrorBlock from '../common/ErrorBlock';
import PasswordInput from '../TextInput/PasswordInput';
import { AUTH } from '../../constants/strings';
import { LOGIN } from '../../constants/routes';
import { actions } from '../../redux/auth/create-password';
import validateForm from '../../utils/auth/createPasswordValidation';
import handleApiError from '../../utils/handleApiError';
import styles from './index.styl';
import MetaHelmet from '../AppHelmet/MetaHelmet';
import { GATrackPageView } from '../../gtag';

const mapStateToProps = (state, ownProps) => ({
  createPasswordReq: state.auth.createPassword,
  token: ownProps.routeParams.token,
});

const mapDispatchToProps = {
  send: actions.send,
};

@injectIntl
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@CSSModules(styles, { allowMultiple: true })
export default class CreatePassword extends PureComponent {
  state = {
    disabled: true,
  };

  componentDidMount() {
    GATrackPageView('Create Password');
  }

  componentWillReceiveProps(nextProps) {
    const { serializedForm } = this.props;
    const {
      intl: { formatMessage },
    } = nextProps;

    if (serializedForm !== nextProps.serializedForm) {
      const form = nextProps.serializedForm;
      const errors = validateForm(form) && formatMessage(AUTH.errors.password);

      this.setState({
        errors,
        submitted: true,
      });
    }
  }

  getValidationErrors = () => {
    const {
      createPasswordReq: { error, rejected },
      intl: { formatMessage },
    } = this.props;
    const { errors, submitted } = this.state;

    if (rejected) {
      return handleApiError(error) || formatMessage(AUTH.errors.common);
    }
    if (submitted) {
      return errors;
    }

    return null;
  };

  render() {
    const { errors, submitted, disabled } = this.state;
    const {
      createPasswordReq: { rejected, succeed },
      getAction,
      getOptions,
      send,
      token,
    } = this.props;

    getOptions({ token });

    if (succeed) {
      // redirect to login
      browserHistory.push(LOGIN);
    }

    if (submitted && !errors) {
      getAction(send);
    }

    const errorEncountered = rejected || (submitted && !!errors);
    const validationErrors = this.getValidationErrors();

    return (
      <div styleName="formWrapper">
        <MetaHelmet title="pages.title.createPassword" />

        <p styleName="formTitle">
          <FormattedMessage {...AUTH.titles.createPassword} />
        </p>
        <p styleName="formText">
          <FormattedMessage {...AUTH.actions.createPassword.textTitle} />
        </p>
        <PasswordInput
          className="mt2 mb4"
          withValidation
          id="create-password"
          required
          rounded
          onChange={(name, value, invalid) =>
            this.setState({ disabled: invalid })
          }
        />
        <If condition={errorEncountered}>
          <ErrorBlock className="mb4" errors={validationErrors} />
        </If>
        <Button className="db w-100" color="primary" raised disabled={disabled}>
          <FormattedMessage {...AUTH.submit.createPassword} />
        </Button>
      </div>
    );
  }
}

CreatePassword.propTypes = {
  createPasswordReq: PropTypes.shape({
    error: PropTypes.object,
    rejected: PropTypes.bool,
    succeed: PropTypes.bool,
  }).isRequired,
  getAction: PropTypes.func.isRequired,
  getOptions: PropTypes.func.isRequired,
  send: PropTypes.func.isRequired,
  serializedForm: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Auth/CreatePassword.jsx